import { render, staticRenderFns } from "./AuditPage.vue?vue&type=template&id=52b3fbd2&scoped=true"
import script from "./AuditPage.vue?vue&type=script&lang=js"
export * from "./AuditPage.vue?vue&type=script&lang=js"
import style0 from "./AuditPage.vue?vue&type=style&index=0&id=52b3fbd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3fbd2",
  null
  
)

export default component.exports